import { Fragment } from "react";
import React from 'react';
export default {
  importTemplateText: '导入模版为例',
  "import": '导入',
  importFile: '导入文件',
  upload: '上传',
  tip: '支持xlsx、xls的文件，<=5MB,单次<=10000条',
  forExample: function forExample(node) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "\u8BF7\u4EE5", node, "\u4E3A\u4F8B");
  },
  importing: '文件导入中...',
  importSuccess: '恭喜您！数据导入成功',
  importCompelate: '数据导入完成',
  successSomeText: function successSomeText(successCount) {
    return "\u6210\u529F" + successCount + "\u6761\uFF0C";
  },
  failSomeText: function failSomeText(errorCount) {
    return "\u5931\u8D25" + errorCount + "\u6761";
  },
  downloadRecord: '下载失败记录',
  importFailed: '数据导入失败',
  tryAgain: '重新导入'
};